// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import Svg_toolip_loader_fallback
    from '../../img/animation/toolip_loader_fallback.svg';
import Svg_oculus_loader_fallback
    from '../../../../oculus/pub/img/animation/oculus_loader_fallback.svg';
import {www_hola} from 'hola_opt';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './splash_screen_loader.module.less';

type t_splash_screen_loader = {
    cls?: string;
    show?: boolean|null;
    site?: 'oculus'|'toolip'|'browserai';
    no_transition?: boolean;
}

export const Splash_screen_loader =
({cls, show = false, site, no_transition = false}: t_splash_screen_loader)=>{
    const is_oculus = (site ?? www_hola.site) == 'oculus';
    return <div className={cn(styles.loader_container, show && styles.shown)}>
      <div className={cn(styles.loader, cls,
        no_transition && styles.no_transition)}>
        {is_oculus ?
          <Lottie autoplay loop width="84px" height="84px"
            fallback_svg={<Svg_oculus_loader_fallback width={84} height={84}/>}
            src={oculus_img_url('animation/oculus_loader_84.json')}/> :
          <Lottie autoplay loop width="96" height="96"
            fallback_svg={<Svg_toolip_loader_fallback width={96} height={96}/>}
            src={toolip_img_url('animation/toolip_loader_96.json')}/>}
      </div>
    </div>;
};
